module.exports = __webpack_public_path__ + "static/media/testimonial-jason-f.bf55821c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/testimonial-jason-f.jpg
// module id = 483
// module chunks = 0